<script>
  export let data;
  let clazz = "";
  export { clazz as class };
</script>

<div>
  {#if data.fields.title}
    <p class="font-heading font-bold {clazz}">
      {data.fields.title}
    </p>
  {/if}
  <p>
    {data.fields.description ? data.fields.description : ""}
  </p>
</div>
